<template>
  <div class="popup-bottom" v-if="show">
    <div class="reply-box">
      <div class="reply-box-head">
        <span @click.stop='closeReply' class="close-icon">
          <img src="../assets/images/close-btn.png" alt="" style="width: 1rem; height: 1rem;" />
        </span>
        <div @click='chooseAnonymous=!chooseAnonymous'>
          <img src='../assets/images/photo_default_icon.png' class="anonymous" v-show='takeYourMask'/><label v-show='takeYourMask'>{{$t('lang.vname')}}</label>
          <img src='../assets/images/photo_default_icon.png' style="border-radius: 50%" class="anonymous" v-show='!takeYourMask'/><label v-show='!takeYourMask'>{{$t('lang.name')}}</label>
          <img src="../assets/images/arrow_down.png" alt="" style="width: .75rem;height: .375rem;margin-left: .5rem;" :class="{rotate180: chooseAnonymous, rotate0: !chooseAnonymous}"/>
        </div>
        <label :class="{'hidden': chooseAnonymous, 'disable': replayInput===''}" @click.stop='add' style="padding: 0 .625rem;">{{$t('lang.send')}}</label>
      </div>
      <div class="reply-box-input">
        <div class="input-content" v-show='!chooseAnonymous'>
          <textarea :placeholder="$t('lang.writeComment')" v-model="replayInput" class='text-area' @blur="scrollTo00"></textarea>
        </div>
        <div class="chooseAnonymous" v-show='chooseAnonymous'>
          <span @click='takeYourMask=true;chooseAnonymous=false'>
            <img src='../assets/images/photo_default_icon.png'/>
            <label>{{$t('lang.vname')}}</label>
          </span>
          <span @click='takeYourMask=false;chooseAnonymous=false'>
            <img :src="headImgUrl" :onerror="defaultHead" style="border-radius:50%"/>
            <label>{{$t('lang.name')}}</label>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMideaConnect } from '../utils/utils'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    headImgUrl: {
      type: String,
      default: ''
    },
    commentParams: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      takeYourMask: true,
      chooseAnonymous: false,
      replayInput: '',
      defaultHead: 'this.src="' + require('../assets/images/photo_default.png') + '"',
      content: ''
    }
  },
  methods: {
    scrollTo00 () {
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 300)
    },
    add () {
      const _p = {
        content: this.replayInput,
        isAnonymous: this.takeYourMask
      }
      if ((!_p.content || _p.content === '')) {
        // this.$store.commit('OPEN_POPUP_REPLY', false)
        // Toast('不能发表空内容的评论')
        this.closeReply()
        this.$toastMessage({ icon: '&#xe7a3;', message1: this.$t('lang.canNotSendEmptyComment') })
        return
      }
      let token, userId, isThirdPartPlat
      const noTokenFlag = this.$store.getters.noTokenFlag
      if (isMideaConnect()) {
        token = this.$store.getters.token
        userId = this.$store.getters.userId
      }
      if (noTokenFlag) {
        isThirdPartPlat = true
        token = null
      } else {
        isThirdPartPlat = !isMideaConnect()
        token = this.$store.getters.token
      }
      if (_p.isAnonymous) {
        // token = ''
        userId = ''
      }
      this.content = _p.content.replace(/&/g, '%26')
      this.$store.dispatch('createCommentMxpOther', {
        isThirdPartPlat: isThirdPartPlat,
        articleId: this.commentParams.id,
        content: this.content,
        isHideName: _p.isAnonymous,
        targetType: this.commentParams.targetType,
        userName: '',
        userId: userId,
        ssoToken: token
      })
        .then(res => {
          console.log(res.data.code)
          if (res.data.code === 0) {
            this.$toastMessage({ icon: '&#xe66f;', message1: this.$t('lang.checkTips'), times: 3000 })
            // 先审后评，这个不需要了
            // this.$store.dispatch('addCommentNum')
            this.replayInput = ''
            this.closeReply()
          } else {
            this.$toastMessage({ icon: '&#xe7a3;', message1: res.data.msg })
          }
        })
      // })
    },
    closeReply () {
      // this.$store.commit('OPEN_POPUP_REPLY', false)
      this.$emit('close')
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.$nextTick(() => {
          /* eslint-disable */
					$('.text-area').focus()
					/* eslint-enable */
        })
      }
    }
  }
}
</script>

<style scoped>
	.popup-bottom {
		position: fixed;
		background: #fff;
		transition: .2s ease-out;
		bottom: 40%;
		top: auto;
		right: auto;
		left: 50%;
		transform: translate3d(-50%, 0, 0);
		z-index: 10005;
		width: 80%;
	}
	.reply-box {
		width: 100%;
		display: block;
		background-color: #ececec;
		font-size: .875rem;
	}
	.reply-box-head {
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		-webkit-box-align: baseline;
		-ms-flex-align: baseline;
		align-items: baseline;
	}
	.close-icon{
		padding: .75rem .625rem .5rem .625rem;
	}
	.anonymous {
		width: 24px;
		height: 24px;
		margin-right: 5px;
		vertical-align: bottom;
	}
	.hidden {
		opacity: 0;
	}
	.reply-box-input {
		padding-left: 10px;
		padding-right: 10px;
		padding-bottom: 10px;
		width: 100%;
	}
	.input-content {
		width: 100%;
		height: 118px;
		border: 1px solid #cecece;
		background-color: #fff;
	}
	.input-content>textarea {
		padding: 5px;
		max-width: -moz-calc(100% - 10px);
		max-width: -webkit-calc(100% - 10px);
		max-width: calc(100% - 10px);
		min-width: -moz-calc(100% - 10px);
		min-width: -webkit-calc(100% - 10px);
		min-width: calc(100% - 10px);
		font-size: 14px;
		height: -moz-calc(100% - 10px);
		height: -webkit-calc(100% - 10px);
		height: calc(100% - 10px);
		outline: none !important;
		-webkit-appearance: none;
		-webkit-user-select: auto;
		border: 0;
	}
	textarea:focus {
      outline: none !important;
	}
	.pic {
		font-size: 32px;
		position: absolute;
		bottom: 15px;
		left: 15px;
	}
	.pic-area {
		top: -15px;
		position: relative;
		display: flex;
		overflow-x: auto;
		padding-top: 15px;
	}
	.image-item {
		position: relative;
		display: inline-block;
		flex-shrink: 0;
		width: 70px;
		height: 70px;
		margin-left: 7px;
		margin-right: 7px;
	}
	img {
		width: 100%;
	}
	.icon {
		position: absolute;
		top: -12px;
		right: -12px;
		font-size: 24px;
	}
	.add-image {
		min-width: 70px;
		height: 70px;
		margin-left: 7px;
		border: 1px solid #c3c1c1;
		font-size: 50px;
		text-align: center;
		color: #c3c1c1;
	}
	.chooseAnonymous {
		width: 100%;
		height: 118px;
		display: flex;
		justify-content: space-around;
		align-items: center;
	}
	.chooseAnonymous span {
		width: 3rem;
		text-align: center;
	}
	.chooseAnonymous img {
		width: 3rem;
		height: 3rem;
	}
	.disable {
		color: #c9c9c9 !important;
	}
	.rotate180 {
		transform: rotate(180deg);
		transition:transform .1s linear;
	}
	.rotate0 {
		transform: rotate(0deg);
		transition:transform .1s linear;
	}
</style>
